import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";
const firebaseConfig = {
    apiKey: "AIzaSyAirQeLPBiH-yo0QzJD9G6O6Rt9LCYyfsE",
    authDomain: "signalreact-native.firebaseapp.com",
    projectId: "signalreact-native",
    storageBucket: "signalreact-native.appspot.com",
    messagingSenderId: "81211648404",
    appId: "1:81211648404:web:01393ad7086a2d622b0781"
  };

  let app;
  if (firebase.apps.length === 0) {
     app = firebase.initializeApp(firebaseConfig);
  } else {
     app= firebase.app();
  }
  const db = app.firestore();
const auth= firebase.auth();
const provider= new firebase.auth.GoogleAuthProvider();
export {auth, provider, db};